import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FetchError from "../../services/api/FetchError";
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";
export default {
  name: "AddEmployee",
  data: function data() {
    var _this$value;

    return {
      employeePhone: (_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.phone,
      employeeName: "",
      user: null,
      error: null,
      loading: false,
      dashboardAccessId: 9,
      FetchError: FetchError,
      Blob: window.Blob,
      showRegisterPopup: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    createUser: function createUser() {
      if (this.employeePhone.length !== 11) {
        this.$vs.notify({
          text: "شماره تلفن را به درستی وارد کنید.",
          position: "bottom-center",
          color: "warning"
        });
        return;
      }

      this.addEmployee(this.employeePhone);
    },
    addEmployee: function addEmployee(phone) {
      var _this = this;

      this.$vs.loading();
      providerApiService.addEmployee(this.currentProvider.id, phone).then(function (result) {
        _this.user = result.resource;

        if (!_this.user.name) {
          _this.showRegisterPopup = true;
        } else {
          _this.$emit("employeeCreated", _this.user);
        }
      }).catch(this.requestFailed).finally(function () {
        return _this.$vs.loading.close();
      });
    },
    requestFailed: function requestFailed(error) {
      this.$vs.notify({
        text: error.error.error ? error.error.error.response.data.message : error.error.response.data.message,
        position: "bottom-center",
        color: "danger"
      });
      this.$vs.loading.close();
    },
    registerUser: function registerUser() {
      var _this2 = this;

      if (this.employeeName) {
        this.user = _objectSpread(_objectSpread({}, this.user), {}, {
          name: this.employeeName
        });
      }

      this.$vs.loading();
      providerApiService.registerUser(this.currentProvider.id, this.user).then(function (result) {
        _this2.$emit("employeeCreated", result.data);
      }).finally(function () {
        return _this2.$vs.loading.close();
      });
    },
    skipRegister: function skipRegister() {
      this.$emit("employeeCreated", this.user);
    }
  },
  props: {
    value: {
      type: Object
    },
    createMode: {
      type: Boolean,
      default: false
    }
  }
};